(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
class StickyHeader extends HTMLElement{
  connectedCallback(){
    this.header=document.querySelector('.section-header');this.headerIsAlwaysSticky=this.dataset.stickyType==='always'||this.dataset.stickyType==='reduce-logo-size';this.currentScrollTop=0;this.setHeaderHeight();
    window.addEventListener('resize',()=>this.setHeaderHeight());
    window.addEventListener('scroll',()=>this.onScroll(),{passive:true});
    if(this.headerIsAlwaysSticky)this.header.classList.add('shopify-section-header-sticky');
  }
  setHeaderHeight(){document.documentElement.style.setProperty('--header-height',`${this.header.offsetHeight}px`);}
  onScroll(){const s=window.scrollY;if(s>this.currentScrollTop&&s>100)this.header.classList.add('shopify-section-header-hidden');else this.header.classList.remove('shopify-section-header-hidden');this.currentScrollTop=s;}
}
customElements.define('sticky-header',StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
